import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { PrivateRoute } from './components/PrivateRoute';
import { Layout } from './components/Layout';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { Shifts } from './pages/Shifts';
import { ShiftRequests } from './pages/ShiftRequests';
import { Users } from './pages/Users';
import { Sites } from './pages/Sites/Sites';
import { Calendar } from './pages/Calendar';
import { EmergencyReports } from './pages/EmergencyReports';
import { SitesOverview } from './pages/SitesOverview';
import { Loyalty } from './pages/Loyalty/Loyalty';
import { Companies } from './pages/Companies/Companies';
import { PrizeManagement } from './pages/PrizeManagement/PrizeManagement';
import { ToastContainer } from './components/Toast';
import './styles/index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ToastContainer />
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />

          {/* Protected routes */}
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/shifts"
            element={
              <PrivateRoute>
                <Layout>
                  <Shifts />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/requests"
            element={
              <PrivateRoute>
                <Layout>
                  <ShiftRequests />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/users"
            element={
              <PrivateRoute requiredRoles={['0', '1', '2']}>
                <Layout>
                  <Users />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/sites"
            element={
              <PrivateRoute requiredRoles={['0', '1']}>
                <Layout>
                  <Sites />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/calendar"
            element={
              <PrivateRoute>
                <Layout>
                  <Calendar />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/emergency-reports"
            element={
              <PrivateRoute>
                <Layout>
                  <EmergencyReports />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/sites-overview"
            element={
              <PrivateRoute requiredRoles={['0', '1', '2']}>
                <Layout>
                  <SitesOverview />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/companies"
            element={
              <PrivateRoute requiredRoles={['0']}>
                <Layout>
                  <Companies />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/prize-management"
            element={
              <PrivateRoute requiredRoles={['0', '1']}>
                <Layout>
                  <PrizeManagement />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/loyalty"
            element={
              <PrivateRoute>
                <Layout>
                  <Loyalty />
                </Layout>
              </PrivateRoute>
            }
          />

          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
